<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- Breadcrumb -->
    <div class="breadcrumb-container">
      <router-link to="/atencion">Atenciones</router-link> >
      <router-link :to="'/atencionform/' + p_idAtencion">Atención {{ p_numero }}</router-link> >
      <router-link :to="{ path: '/atencionform/' + p_idAtencion, query: { tab: 'tratamiento' } }">
        Plan de Tratamiento
      </router-link> >
      <b>Receta</b>
    </div>
    <hr>

    <!--  Master  -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-body form-card">

          <div class="mb-3">
            <label class="form-label">Observaciones generales</label>
            <textarea class="form-control" rows="3" maxlength="250"
                      v-model="datoReceta.observacion"
                      style="text-transform:uppercase"
                      placeholder="Ingrese observaciones generales para la receta"></textarea>
          </div>

          <div class="observaciones">
            <div v-for="obs in observacionesCatalogo" :key="obs.codigo">
              <input type="checkbox" :id="obs.codigo"
                     :value="obs.texto" v-model="observacionesSeleccionadas">
              <label :for="obs.codigo">{{ obs.texto }}</label>
            </div>
          </div>

          <button @click.prevent="mostrarBloque = !mostrarBloque" class="mt-2">
            {{ mostrarBloque ? '(-) Menos información' : '(+) Más información' }}
          </button>

          <div v-if="mostrarBloque" class="mt-3">
            <div class="row">
              <div class="col-4">
                <label class="form-label">Id. Receta</label>
                <input type="text" class="form-control" :value="datoReceta.idReceta" disabled>
              </div>
              <div class="col-4">
                <label class="form-label">Fecha de Registro</label>
                <input type="text" class="form-control"
                       :value="getFormattedDate(datoReceta.fechaReg)" disabled>
              </div>
              <div class="col-4">
                <label class="form-label">Fecha de Actualización</label>
                <input type="text" class="form-control"
                       :value="getFormattedDate(datoReceta.fechaAct)" disabled>
              </div>
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button v-if="btnCrear" type="button" class="btn btn-light"
                  @click.prevent="guardarReceta()">
            <i class="material-icons" style="font-size:32px;color:blue;cursor:pointer">save</i>
          </button>
          <button v-if="btnEditar && estadoPermitido" type="button" class="btn btn-success"
                  @click.prevent="guardarEditReceta()">
            <span class="material-symbols-outlined align-middle" style="font-size:32px">update</span>
            Actualizar
          </button>
        </div>
      </div>
    </div>

    <hr>

    <!--  DataTable detalles  -->
    <DataTable
      :data="recetadets"
      :columns="columnas"
      idField="idRecetaDet"
      :acciones="true"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="estadoPermitido"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="estadoPermitido"
      mensajeVacio="No hay medicamentos registrados en la receta."
      @refresh="cargarDetalles()"
      @create="abrirModalCrear"
      @edit="({ idRecetaDet }) => abrirModalEditar(idRecetaDet)"
      @delete="({ idRecetaDet }) => deleteRecetaDet(idRecetaDet)"
    >
      <!-- Celda: Duración con singular/plural -->
      <template #cell-duracion="{ row }">
        {{ row.duracion }} {{ row.duracion === 1 ? 'día' : 'días' }}
      </template>
    </DataTable>

    <!--  Modal crear / editar medicamento  -->
    <div class="modal fade" id="ventanaModal" tabindex="-1"
         aria-labelledby="modalRecetaDetLabel" aria-hidden="true"
         v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalRecetaDetLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white"
                    data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body form-card">

            <!-- LOV Elemento -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Elemento</label></div>
                <div class="col-11">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           v-model="searchTextElem"
                           @input="filterElementos()"
                           @keyup.enter="toggleDropdown()"
                           placeholder="Buscar elemento...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button" data-bs-toggle="dropdown"
                            aria-expanded="false" ref="dropdownButton">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height:250px;overflow-y:auto;width:100%">
                      <li v-for="elem in filteredElementos" :key="elem.idElemento">
                        <a class="dropdown-item text-truncate" href="#"
                           @click.prevent="selectElemento(elem)"
                           :title="`${elem.clasElemNombre} - ${elem.codigo} - ${elem.nombre}`">
                          {{ elem.clasElemNombre }} - {{ elem.codigo }} - {{ elem.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- LOV Dosis -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Dosis</label></div>
                <div class="col-11">
                  <div class="input-group">
                    <input type="text" class="form-control"
                           v-model="searchTextDosis"
                           @input="filterDosis()"
                           @keyup.enter="toggleDropdownDosis()"
                           placeholder="Buscar dosis...">
                    <button class="btn btn-outline-secondary dropdown-toggle"
                            type="button" data-bs-toggle="dropdown"
                            aria-expanded="false" ref="dropdownButtonDosis">
                      <i class="fa fa-search"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end shadow"
                        style="max-height:250px;overflow-y:auto;width:100%">
                      <li v-for="dosis in filteredDosiss" :key="dosis.idDosis">
                        <a class="dropdown-item text-truncate" href="#"
                           @click.prevent="selectDosis(dosis)"
                           :title="dosis.dosisNombre">
                          {{ dosis.dosisNombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Frecuencia -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Frecuencia</label></div>
                <div class="col-3">
                  <select class="form-select" v-model="datoRecetaDet.idFrecuencia">
                    <option v-for="f in frecuencias" :value="f.idFrecuencia" :key="f.idFrecuencia">
                      {{ f.descripcion }}
                    </option>
                  </select>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarFrecuencia(1)">QD</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarFrecuencia(2)">BID</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarFrecuencia(3)">TID</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarFrecuencia(4)">QID</button>
                </div>
              </div>
            </div>

            <!-- Duración -->
            <div class="mb-3">
              <div class="row align-items-center">
                <div class="col-1"><label class="form-label">Duración (días)</label></div>
                <div class="col-3">
                  <input type="number" class="form-control"
                         v-model="datoRecetaDet.duracion" min="1" required>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarDuracion(3)">3</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarDuracion(7)">7</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarDuracion(15)">15</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary btn-fixed-width"
                          @click="asignarDuracion(30)">30</button>
                </div>
              </div>
            </div>

            <!-- Indicación con micrófono -->
            <div class="mb-3">
              <div class="row">
                <div class="col-12">
                  <label class="form-label">Indicación</label>
                  <div class="textarea-container-mic d-flex align-items-stretch">
                    <textarea class="form-control"
                              v-model="datoRecetaDet.indicacion"
                              style="text-transform:uppercase"
                              maxlength="250" required></textarea>
                    <div class="buttons-container-mic d-flex flex-column ms-2">
                      <button v-if="!isDictating" type="button"
                              class="btn btn-light" title="Iniciar Dictado"
                              @click="startDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:orangered;cursor:pointer">mic_off</span>
                      </button>
                      <button v-else type="button"
                              class="btn btn-light" title="Finalizar Dictado"
                              @click="stopDictation()">
                        <span class="material-symbols-outlined"
                              style="font-size:40px;color:green;cursor:pointer">mic</span>
                      </button>
                      <div class="flex-grow-1"></div>
                      <small class="text-muted mt-auto text-end">
                        {{ (datoRecetaDet.indicacion || '').length }} / 250
                      </small>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Condiciones de ingesta -->
            <div class="condiciones-ingesta">
              <h5>Condiciones de ingesta</h5>
              <div>
                <input type="radio" id="enAyunas" value="enAyunas"
                       v-model="condiciones.condicionSeleccionada"
                       @change="updateIndicacion()">
                <label for="enAyunas">&nbsp;En ayunas (30–60 min antes)</label>
              </div>
              <div>
                <input type="radio" id="estomagoLleno" value="estomagoLleno"
                       v-model="condiciones.condicionSeleccionada"
                       @change="updateIndicacion()">
                <label for="estomagoLleno">&nbsp;Con alimentos (con el estómago lleno)</label>
              </div>
              <div>
                <input type="radio" id="ninguna" value="ninguna"
                       v-model="condiciones.condicionSeleccionada"
                       @change="updateIndicacion()">
                <label for="ninguna">&nbsp;Independiente de las comidas</label>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button v-if="btnCrear_det" type="button" class="btn btn-success"
                    @click.prevent="guardarRecetaDet()">
              <span class="material-symbols-outlined align-middle" style="font-size:32px">save</span>
              Guardar
            </button>
            <button v-if="btnEditar_det" type="button" class="btn btn-success"
                    @click.prevent="guardarEditRecetaDet()">
              <span class="material-symbols-outlined align-middle" style="font-size:32px">update</span>
              Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!--  Modal interacciones medicamentosas  -->
    <div v-if="mostrarModalAlertas"
         style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:2000;
                display:flex;align-items:center;justify-content:center;padding:16px">
      <div style="background:#fff;border-radius:12px;width:100%;max-width:580px;
                  max-height:85vh;overflow-y:auto;border-top:4px solid #dc3545">
        <div class="p-3 border-bottom d-flex justify-content-between align-items-center">
          <h5 class="mb-0 text-danger">
            <i class="material-icons align-middle" style="font-size:20px">warning</i>
            Interacciones medicamentosas detectadas
          </h5>
          <button type="button" class="btn-close"
                  @click="mostrarModalAlertas = false"></button>
        </div>
        <div class="p-3">
          <div v-for="alerta in alertasInteraccion" :key="alerta.idInteraccionMed"
               class="alert mb-2"
               :class="alerta.severidad >= 3 ? 'alert-danger' : 'alert-warning'">
            <div class="d-flex align-items-center gap-2 mb-1">
              <span class="badge"
                    :class="alerta.severidad >= 3 ? 'bg-danger' : 'bg-warning text-dark'">
                {{ alerta.severidad >= 3 ? 'GRAVE' : 'MODERADA' }}
              </span>
              <strong>{{ alerta.nombreElemento1 }} + {{ alerta.nombreElemento2 }}</strong>
            </div>
            <p class="mb-1 small">{{ alerta.descripcion }}</p>
            <p class="mb-0 small">
              <strong>Recomendación:</strong> {{ alerta.recomendacion }}
            </p>
          </div>
        </div>
        <div class="p-3 border-top d-flex justify-content-end gap-2">
          <button class="btn btn-outline-secondary"
                  @click="mostrarModalAlertas = false; datoRecetaDet.idElemento = null; searchTextElem = ''">
            Cambiar medicamento
          </button>
          <button class="btn btn-warning"
                  @click="mostrarModalAlertas = false">
            Continuar de todos modos
          </button>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from '@/components/Layout.vue'
import Footer          from '@/components/Footer.vue'
import DataTable       from '@/components/DataTable.vue'
import { validarForm } from '@/modules/validacionesForms.js'
import SpeechDictation from '@/modules/microfono.js'
import dateFormat      from '@/modules/dateFormat.js'
import api             from '@/services/api'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal            from 'sweetalert'

export default {
  name: 'RecetaForm',

props: {
  p_idAtencion:     { type: Number, required: true },
  p_estadoAtencion: { type: String, required: true },
  p_numero:         { type: String, required: true },
},

  components: { Layout, Footer, DataTable },

  data() {
    return {
      // Master
      datoReceta:              {},
      btnCrear:                false,
      btnEditar:               false,
      mostrarBloque:           false,
      idPersona:               null,

      // Detalle
      recetadets:              [],
      datoRecetaDet:           {},
      titulo:                  '',
      btnCrear_det:            false,
      btnEditar_det:           false,
      modalWindow:             true,
      elementos:               [],
      frecuencias:             [],
      dosiss:                  [],
      filteredElementos:       [],
      filteredDosiss:          [],
      searchTextElem:          '',
      searchTextDosis:         '',
      dictation:               new SpeechDictation(),
      isDictating:             false,
      alertasInteraccion:      [],
      mostrarModalAlertas:     false,
      condiciones:             { condicionSeleccionada: '' },

      observacionesCatalogo: [
        { codigo: 'OG01', texto: 'Cumplir el tratamiento según indicación médica.' },
        { codigo: 'OG02', texto: 'Completar el tratamiento aunque los síntomas mejoren.' },
        { codigo: 'OG03', texto: 'Acudir a control médico si los síntomas persisten o empeoran.' },
      ],
      observacionesSeleccionadas: [],

      columnas: [
        { field: 'clasElemNombre',  label: 'Clase' },
        { field: 'elementoCodigo',  label: 'Código' },
        { field: 'elementoNombre',  label: 'Nombre/Descripción' },
        { field: 'dosisNombre',     label: 'Dosis' },
        { field: 'frecuenciaNombre',label: 'Frecuencia' },
        { field: 'duracion',        label: 'Duración' },
        { field: 'indicacion',      label: 'Indicación' },
      ],
    }
  },

  watch: {
    observacionesSeleccionadas: {
      deep: true,
      handler(v) { this.datoReceta.observacion = v.join(' ') },
    },
    'datoRecetaDet.idElemento'(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.fetchDosiss(newVal)
    },
    'datoRecetaDet.idDosis'(newVal) {
      if (newVal) {
        const found = this.dosiss.find(d => d.idDosis === newVal)
        this.searchTextDosis = found ? found.dosisNombre : ''
      }
    },
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion)
    },
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
    await this.abrirEditar(this.p_idAtencion)
    this.cargarDetalles()
    this.fetchElementos()
    this.fetchFrecuencias()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    //  Master
    validarForm() {
      return validarForm(
        this.datoReceta,
        ['idTratamiento', 'observacion'],
        ['idTratamiento', 'observacion']
      )
    },

    async guardarReceta() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/recetas', this.datoReceta)
        swal('Correcto!', 'Receta creada exitosamente!', 'success')
      } catch { swal('Error!', 'Inténtelo de nuevo!', 'error') }
    },

    async guardarEditReceta() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/recetas', this.datoReceta)
        swal('Correcto!', 'Receta actualizada exitosamente!', 'success')
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async abrirEditar(idAtencion) {
      if (idAtencion) {
        const { data: receta }   = await api.get(`/vwrecetas/idatencion/${idAtencion}`)
        const { data: atencion } = await api.get(`/vwatencions/${idAtencion}`)
        this.datoReceta = receta
        this.idPersona  = atencion.idPersona
      }
      this.btnCrear  = false
      this.btnEditar = true
    },

    //  Detalles
    cargarDetalles() {
      if (!this.datoReceta.idReceta) return
      api.get(`/vwrecetadets/idreceta/${this.datoReceta.idReceta}`)
        .then(response => { this.recetadets = response.data.reverse() })
        .catch(error   => console.error('Error cargando detalles:', error))
    },

    async guardarRecetaDet() {
      if (this.validarForm() !== 1) return
      try {
        if (this.idPersona && this.datoRecetaDet.idElemento) {
          const alertas = await this.verificarInteracciones(this.datoRecetaDet.idElemento)
          if (alertas.some(a => a.severidad >= 3)) {
            const confirmar = await swal({
              title: '¡Interacción grave!',
              text: 'Este medicamento tiene interacciones graves. ¿Desea continuar?',
              icon: 'warning',
              buttons: ['Cancelar', 'Guardar de todos modos'],
              dangerMode: true,
            })
            if (!confirmar) return
          }
        }
        this.datoRecetaDet.idReceta = this.datoReceta.idReceta
        await api.post('/recetadets', this.datoRecetaDet)
        closeModal('ventanaModal')
        this.mostrarModalAlertas = false
        swal('Correcto!', 'Medicamento registrado exitosamente!', 'success')
        this.cargarDetalles()
      } catch { swal('Error!', 'Inténtelo de nuevo!', 'error') }
    },

    async guardarEditRecetaDet() {
      if (this.validarForm() !== 1) return
      try {
        await api.post('/recetadets', this.datoRecetaDet)
        closeModal('ventanaModal')
        swal('Correcto!', 'Medicamento actualizado exitosamente!', 'success')
        this.cargarDetalles()
      } catch (error) {
        swal('Error!', 'Inténtelo de nuevo!', 'error')
        if (error.response?.data?.errors) {
          Object.values(error.response.data.errors).forEach(e => swal(String(e)))
        }
      }
    },

    async deleteRecetaDet(idRecetaDet) {
      try {
        await api.delete(`/recetadets/${idRecetaDet}`)
        this.cargarDetalles()
      } catch { swal('Error!', 'No se pudo eliminar.', 'error') }
    },

    abrirModalCrear() {
      this.modalWindow     = true
      this.datoRecetaDet   = {}
      this.searchTextElem  = ''
      this.searchTextDosis = ''
      this.titulo          = 'Registrar Medicamento'
      this.btnCrear_det    = true
      this.btnEditar_det   = false
      openModal('ventanaModal')
    },

    abrirModalEditar(idRecetaDet) {
      this.modalWindow = true
      if (idRecetaDet) {
        api.get(`/vwrecetadets/${idRecetaDet}`).then(resp => {
          this.datoRecetaDet   = resp.data
          this.searchTextElem  = `${resp.data.elementoCodigo} - ${resp.data.elementoNombre}`
          this.searchTextDosis = resp.data.dosisNombre
        })
      }
      this.titulo        = 'Editar Medicamento'
      this.btnCrear_det  = false
      this.btnEditar_det = true
      openModal('ventanaModal')
    },

    //  LOV Elementos
    fetchElementos() {
      api.get('/vwelementos/idtipoelem/2')
        .then(response => {
          this.elementos         = response.data
          this.filteredElementos = response.data
        })
        .catch(error => console.error('Error fetching elementos:', error))
    },

    filterElementos() {
      const q = this.searchTextElem.toLowerCase()
      this.filteredElementos = q
        ? this.elementos.filter(e => e.nombre.toLowerCase().includes(q))
        : this.elementos
    },

    async selectElemento(elemento) {
      this.datoRecetaDet.idElemento = elemento.idElemento
      this.searchTextElem = `${elemento.codigo} - ${elemento.nombre}`
      if (this.idPersona) {
        const alertas = await this.verificarInteracciones(elemento.idElemento)
        this.alertasInteraccion  = alertas
        this.mostrarModalAlertas = alertas.length > 0
      }
    },

    toggleDropdown() {
      this.$refs.dropdownButton.click()
    },

    //  LOV Dosis
    async fetchDosiss(idElemento) {
      try {
        const { data } = await api.get(`/vwdosismeds/idelemento/${idElemento}`)
        if (data.length > 0) {
          this.dosiss = data.map(d => ({ idDosis: d.idDosis, dosisNombre: d.dosisNombre }))
        } else {
          const { data: general } = await api.get('/vwdosiss')
          this.dosiss = general.map(d => ({ idDosis: d.idDosis, dosisNombre: d.nombre }))
        }
        this.filteredDosiss = this.dosiss
      } catch {
        const { data: general } = await api.get('/vwdosiss')
        this.dosiss         = general.map(d => ({ idDosis: d.idDosis, dosisNombre: d.nombre }))
        this.filteredDosiss = this.dosiss
      }
    },

    filterDosis() {
      const q = this.searchTextDosis.toLowerCase()
      this.filteredDosiss = q
        ? this.dosiss.filter(d => d.dosisNombre.toLowerCase().includes(q))
        : this.dosiss
    },

    selectDosis(dosis) {
      this.datoRecetaDet.idDosis = dosis.idDosis
      this.searchTextDosis       = dosis.dosisNombre
      this.$refs.dropdownButtonDosis.click()
    },

    toggleDropdownDosis() {
      this.$refs.dropdownButtonDosis.click()
    },

    //  Frecuencia y duración
    fetchFrecuencias() {
      api.get('/vwfrecuencias')
        .then(response => { this.frecuencias = response.data })
        .catch(error   => console.error('Error fetching frecuencias:', error))
    },

    asignarFrecuencia(id) {
      this.datoRecetaDet.idFrecuencia = id
    },

    asignarDuracion(dias) {
      this.datoRecetaDet.duracion = dias
      const elem = this.elementos.find(e => e.idElemento === this.datoRecetaDet.idElemento)
      const frec = this.frecuencias.find(f => f.idFrecuencia === this.datoRecetaDet.idFrecuencia)
      this.datoRecetaDet.indicacion =
        `${elem?.nombre ?? ''} ${frec?.descripcion ?? ''} por ${dias} días`
    },

    //  Indicación
    updateIndicacion() {
      let obs = (this.datoRecetaDet.indicacion || '')
        .replace('; En ayunas (30–60 min antes)', '')
        .replace('; Con alimentos (con el estómago lleno)', '')
        .replace('; Independiente de las comidas', '')
        .trim()
      const map = {
        enAyunas:      '; En ayunas (30–60 min antes)',
        estomagoLleno: '; Con alimentos (con el estómago lleno)',
        ninguna:       '; Independiente de las comidas',
      }
      this.datoRecetaDet.indicacion = obs + (map[this.condiciones.condicionSeleccionada] ?? '')
    },

    //  Interacciones
    async verificarInteracciones(idNuevoElemento) {
      try {
        const { data: activos } = await api.get(`/medicamentos-activos/${this.idPersona}`)
        const ids = [...new Set([...activos.map(m => m.idElemento), idNuevoElemento])]
        if (ids.length < 2) return []
        const { data } = await api.post('/interaccion-med/validar-lista', ids)
        return data
      } catch (error) {
        console.error('Error verificando interacciones:', error)
        return []
      }
    },

    //  Micrófono
    startDictation() {
      this.isDictating = true
      this.dictation.startDictation(
        transcript => { this.datoRecetaDet.indicacion = transcript },
        this.datoRecetaDet.indicacion
      )
    },
    stopDictation() {
      this.isDictating = false
      this.dictation.stopDictation()
    },
  },
}
</script>

<style src="@/assets/css/microfono.css" scoped></style>
<style src="@/assets/css/listaFiltrada02.css" scoped></style>
<style scoped>
.observaciones {
  margin: 5px; padding: 5px;
  border: 1px solid #dcdcdc; border-radius: 2px;
  background-color: #f9f9f9;
}
.observaciones label { margin-left: 8px; cursor: pointer; }
.condiciones-ingesta {
  margin: 20px; padding: 15px;
  border: 1px solid #ccc; background-color: #f9f9f9;
}
.btn-fixed-width { width: 100px; }
</style>